import React from "react";
import { useDispatch, useSelector } from "react-redux"
import { FormattedMessage } from "react-intl";
import classNames from "classnames";
import { updatePagination } from "../../../../redux/slices/cvSlice";

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100, 500];

const Pagination = ({ total = 0, disabled = false, reset }) => {
  const dispatch = useDispatch();
  const pagination = useSelector((state) => state.cv.pagination);
  const { limit: pageSize, offset } = pagination;

  const totalPages = pagination ? Math.ceil((total || 1) / pageSize) : 1;
  const currentPage = Math.floor(offset / pageSize) + 1;

  const setCurrentPage = (newPage) =>
    dispatch(updatePagination({
      offset: (newPage - 1) * pageSize
    }))

  return (
    <div className={classNames("pagination", { "pagination--disabled": disabled })}>
      <button
        className=""
        onClick={() => !disabled && setCurrentPage(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1 || disabled}
      >
        {frontArrow}
      </button>

      <span>
        <FormattedMessage id="common.page" /> {currentPage}/{totalPages}
      </span>

      <button
        onClick={() => !disabled && setCurrentPage(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages || disabled}
      >
        {nextArrow}
      </button>

      <label>
        <FormattedMessage id="common.pageSize" />
        <select
          value={pageSize}
          onChange={({ target }) => {
            if (disabled) return;

            const newPageSize = Number(target.value);
            dispatch(updatePagination({
              offset: 0, // Restart to page 1
              limit: newPageSize
            }));
          }}
          disabled={disabled}
          className={classNames({ "disabled": disabled })}
        >
          {PAGE_SIZE_OPTIONS.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
};

const nextArrow = (
  <svg width="12" height="12" viewBox="0 0 9 10" fill="none">
    <path
      d="M8.33972 5.23237L0.839721 0.902245L0.839722 9.5625L8.33972 5.23237Z"
      fill="currentColor"
    />
  </svg>
);

const frontArrow = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 8 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.339722 5.23237L7.83972 0.902245L7.83972 9.5625L0.339722 5.23237Z"
      fill="currentColor"
    />
  </svg>
);

export default Pagination;